import { useTranslation } from 'react-i18next';

import { Stack } from '@mui/material';

import Tag from '../../../components/Tag';
import Typography from '../../../components/Typography';
import { CourseListItem } from '../../../db/courses/types';
import { i18nNS } from '../../../i18n';
import { format } from '../../../utils/datetime';
import { translateCourseRole } from './helpers';
import { Root } from './styles';

export interface CourseWidgetProps extends CourseListItem {
  className?: string;
}

const CourseWidget = ({ code, title, nextLecture, role, className }: CourseWidgetProps) => {
  const { t } = useTranslation([i18nNS.COURSE]);

  return (
    <Root className={className}>
      <Stack direction="row" alignItems="center" gap={1.25} px={1.25} py={0.5}>
        <Typography flex={1} variant="paragraphBold" component="h6" textTransform="uppercase">
          {code}
        </Typography>
        <Tag variant="outlined" color="primary" label={translateCourseRole(role)} />
      </Stack>
      <Typography variant="paragraphRegular" noWrap p={1.25}>
        {title}
      </Typography>
      <Typography variant="paragraphRegular" px={1.25} py={0.5}>
        <strong>{`${t('next_lecture', { ns: i18nNS.COURSE })}: `}</strong>
        {nextLecture > 0 ? format(nextLecture, 'do MMMM, yyyy') : t('not_scheduled', { ns: i18nNS.COURSE })}
      </Typography>
    </Root>
  );
};

export default CourseWidget;
